<!-- 广告管理 -->

<style scoped>
.img {
  /* width:30px; */
  height: 30px;
}
.ellipsis-1 {
  max-width: 180px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-wrap: break-word;
  word-break: break-all;
}
.w150 {
  width: 150px;
}
</style>
<template>
  <div class="pageCentent">
    <a-form-model size="small" layout="inline" @keyup.native.enter="search()">
      <a-form-model-item label="姓名">
        <a-input
          placeholder="请输入姓名"
          v-model="ajaxparams['company_name_like']"
        />
      </a-form-model-item>
      <a-form-model-item label="业务经理">
        <a-input
          placeholder="请输入业务经理"
          v-model="ajaxparams['manager_name_no']"
        />
      </a-form-model-item>
      <a-form-model-item label="省份">
        <a-select
          style="width: 200px"
          allowClear
          v-model="ajaxparams['province']"
          placeholder="请选择省份"
          :showSearch="true"
          optionFilterProp="label"
        >
          <a-select-option
            :label="item.name"
            :value="item.name"
            v-for="(item, index) in provinceData"
            :key="index"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="部门">
        <a-select
          style="width: 120px"
          allowClear
          v-model="ajaxparams.team_id_no"
          placeholder="请选择部门"
        >
          <a-select-option value="1">雄狮队</a-select-option>
          <a-select-option value="2">战狼队</a-select-option>
          <a-select-option value="3">雄鹰队</a-select-option>
          <a-select-option value="4">雪豹队</a-select-option>
          <a-select-option value="5">预备1队</a-select-option>
          <a-select-option value="6">预备2队</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="资料状态">
        <a-select
          style="width: 120px"
          allowClear
          v-model="ajaxparams.status"
          placeholder="请选择资料状态"
        >
          <a-select-option value="1">公选</a-select-option>
          <a-select-option value="2">自选</a-select-option>
          <a-select-option value="3">已转化</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="地址">
        <a-input
          placeholder="请输入地址"
          v-model="ajaxparams['register_address_like']"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button icon="search" @click="$refs.myTable.search()" type="primary">
          搜索</a-button
        >
      </a-form-model-item>
    </a-form-model>
    <div>
      <MyTable
        class="mt10"
        :isSelection="false"
        :apiUrl="apiUrl"
        :params="ajaxparams"
        ref="myTable"
        :columns="columns"
      >
        <a-space slot="status" slot-scope="item, row, index">
          <span>{{
            row.status == 1 ? "公选" : row.status == 2 ? "自选" : "已转化"
          }}</span>
        </a-space>
        <a-space slot="button" slot-scope="item, row, index">
          <a-button @click="openToLog(row)" size="small" type="link"
            >沟通详情</a-button
          >
          <a-button size="small" @click="showChangeRemarkDialog(row)">
            修改备注
          </a-button>
        </a-space>
      </MyTable>
    </div>
    <a-modal
      :title="'修改备注'"
      :visible="showRemarkDialog"
      @ok="changeRemark"
      @cancel="showRemarkDialog = false"
    >
      <a-form-model-item label="备注">
        <a-textarea
          placeholder="请输入备注信息"
          v-model="remark"
          :auto-size="{ minRows: 3, maxRows: 8 }"
        >
        </a-textarea>
      </a-form-model-item>
    </a-modal>
  </div>
</template>
<script>
import MyTable from "@/components/myTable.vue";
import { nongzi_index, nongzi_changeRemark } from "@/api/manager";
export default {
  components: { MyTable },
  data() {
    return {
      apiUrl: nongzi_index,
      ajaxparams: {},
      showRemarkDialog: false,
      currentId: 0,
      remark: "",
      columns: [
        {
          title: "姓名",
          ellipsis: true,
          dataIndex: "company_name",
          key: "company_name",
          width: 120,
        },
        {
          title: "电话号码",
          ellipsis: true,
          dataIndex: "mobile",
          key: "mobile",
          width: 120,
        },
        {
          title: "市场",
          ellipsis: true,
          dataIndex: "status",
          key: "status",
          width: 120,
          scopedSlots: { customRender: "status" },
        },
        {
          title: "法人",
          dataIndex: "legal_person",
          key: "legal_person",
          width: 120,
        },
        {
          title: "地址",
          ellipsis: true,
          dataIndex: "register_address",
          key: "register_address",
          width: 120,
        },
        {
          title: "状态",
          ellipsis: true,
          dataIndex: "status",
          key: "status",
          width: 100,
          scopedSlots: { customRender: "status" },
        },
        {
          title: "备注",
          width: 200,
          dataIndex: "remark",
          key: "remark",
        },
        {
          title: "操作",
          key: "operation",
          fixed: "right",
          width: 200,
          scopedSlots: { customRender: "button" },
        },
      ],
      provinceData: [],
      regionData: [],
    };
  },
  created() {
    this.regionData = this.$db.get("regionList").data;
    this.provinceData = this.regionData.filter((item) => {
      return item.depth == 1;
    });
  },
  mounted() {},
  destroyed() {},
  methods: {
    openToLog(row) {
      this.$router.push("/manager/contactLog?id=" + row.id + "&role=2");
    },
    showChangeRemarkDialog(row) {
      this.showRemarkDialog = true;
      this.currentId = row.id;
      this.remark = row.remark || "";
    },
    changeRemark() {
      if (!this.currentId || !this.remark) {
        this.$message.error("请输入备注信息");
        return false;
      }
      nongzi_changeRemark({ id: this.currentId, remark: this.remark }).then(
        (res) => {
          this.$message.success("操作成功");
          setTimeout(() => {
            this.$refs.myTable.getList();
            this.showRemarkDialog = false;
          }, 1200);
        }
      );
    },
  },
};
</script>
	